import getFolderTable from './getFolderTable';

export function hasDisplayableChildFolders(folderId: string): boolean {
    const folder = getFolderTable().get(folderId);

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (9,10): Object is possibly 'undefined'.
    // @ts-expect-error
    if (!folder.childFolderIds) {
        return false;
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (16,28): Object is possibly 'undefined'.
    // @ts-expect-error
    const visibleFolders = folder.childFolderIds.map((childFolderId: string) => {
        const childFolder = getFolderTable().get(childFolderId);
        return !!childFolder;
    });

    return visibleFolders.length > 0;
}
